module.exports = __webpack_public_path__ + "media/images/flags/4x3/mex-10f3746db81fffc5894c6b5ca91247de.svg";